"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { BrowserWindow } from "@/components/browser-window";
import { CouponDiscountIcon, GlobeMinusIcon, PointClickIcon } from "@/components/icons/icons";
import { cn } from "@/utils";
const cards = [{
  title: "Add Products in Seconds",
  description: "Type, click, done – your products are live.",
  icon: PointClickIcon,
  video: {
    mp4: "/yns-video-1.mp4",
    webm: "/yns-video-1.webm",
    poster: "/yns-video-1.jpg"
  }
}, {
  title: " Build It Your Way",
  description: "Designing a store has never been this fun – or this fast.",
  icon: CouponDiscountIcon,
  video: {
    mp4: "/yns-video-2.mp4",
    webm: "/yns-video-2.webm",
    poster: "/yns-video-2.jpg"
  }
}, {
  title: "Launch Lightning-Fast",
  description: "Speed that makes your old store jealous.",
  icon: GlobeMinusIcon,
  video: {
    mp4: "/yns-video-3.mp4",
    webm: "/yns-video-3.webm",
    poster: "/yns-video-3.jpg"
  }
}];
export const FeatureVideos = () => {
  const $ = _c(9);
  const [active, setActive] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const videosRef = useRef(t0);
  let t1;
  let t2;
  if ($[1] !== active) {
    t1 = () => {
      if (videosRef.current[active]) {
        videosRef.current[active]?.play();
      }
      videosRef.current.forEach((video, index) => {
        if (video && index !== active) {
          video.pause();
        }
      });
    };
    t2 = [active];
    $[1] = active;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="sr-only">YNS most important features</h2>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== active) {
    t4 = cards.map((card, index_0) => <FeatureCard key={index_0} title={card.title} description={card.description} icon={card.icon} align={index_0 === 0 ? "left" : index_0 === 1 ? "center" : "right"} className={cn(index_0 === 0 ? "relative" : "md:absolute top-0 left-0 right-0")} active={active === index_0} onClick={() => setActive(index_0)} ref={el => {
      videosRef.current[index_0] = el;
      const fn = () => {
        setActive((index_0 + 1) % cards.length);
      };
      el?.addEventListener("ended", fn);
      return () => {
        el?.removeEventListener("ended", fn);
      };
    }} video={card.video} />);
    $[5] = active;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <section className="mt-10 px-4 pt-10 bg-gradient-to-b from-0% to-[1.5rem] from-[#fafafa] to-transparent" id="features">{t3}<div className="grid gap-12 relative">{t4}</div></section>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
const FeatureCard = t0 => {
  const $ = _c(47);
  const {
    title,
    description,
    icon: Icon,
    align,
    className,
    active,
    onClick,
    ref,
    video
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = active && "z-30";
  let t3;
  if ($[2] !== t2) {
    t3 = cn(t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== video.webm) {
    t4 = <source src={video.webm} type="video/webm" />;
    $[4] = video.webm;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== video.mp4) {
    t5 = <source src={video.mp4} type="video/mp4" />;
    $[6] = video.mp4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== ref || $[9] !== t4 || $[10] !== t5 || $[11] !== video.poster) {
    t6 = <video controls={false} autoPlay={false} muted={true} className="w-full h-full object-cover rounded-xs" ref={ref} poster={video.poster}>{t4}{t5}</video>;
    $[8] = ref;
    $[9] = t4;
    $[10] = t5;
    $[11] = video.poster;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onClick || $[14] !== t3 || $[15] !== t6) {
    t7 = <BrowserWindow className={t3} onClick={onClick}>{t6}</BrowserWindow>;
    $[13] = onClick;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("grid md:grid-cols-3");
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = `Select video ${title}`;
  const t10 = align === "left";
  const t11 = align === "center";
  const t12 = align === "right";
  let t13;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t12) {
    t13 = cn("appearance-none text-left", "group relative grid grid-cols-[calc((100vw-1rem*2)/4)_1fr] pt-6 pr-4 bg-[linear-gradient(transparent_0%,#fafafad0_30%,#fafafad0_70%,transparent_100%)]", "md:grid-cols-[5rem_1fr] md:gap-4", {
      "md:col-start-1 relative z-10": t10,
      "md:col-start-2 relative z-10": t11,
      "md:col-start-3 relative z-10": t12
    });
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = active && "opacity-50";
  let t15;
  if ($[22] !== t14) {
    t15 = cn("absolute opacity-0 group-hover:opacity-50 transition-opacity -top-1/2 left-1/2 -translate-x-1/2 w-[150px] fill-brand-500 blur-[50px]", "md:scale-150", t14);
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <ellipse cx="100" cy="50" rx="100" ry="50" />;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t15) {
    t17 = <svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg" className={t15}>{t16}</svg>;
    $[25] = t15;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== Icon) {
    t18 = <Icon className="justify-self-center text-neutral-400 group-hover:text-brand-500 transition-colors md:justify-self-end" />;
    $[27] = Icon;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== title) {
    t19 = <h3 className="text-h6 leading-h6 tracking-h6 font-medium group-hover:text-black transition-colors">{title}</h3>;
    $[29] = title;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== description) {
    t20 = <p className="text-pregular leading-pregular tracking-pregular text-neutral-400 group-hover:text-pregular-500 transition-colors mt-1">{description}</p>;
    $[31] = description;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t19 || $[34] !== t20) {
    t21 = <div>{t19}{t20}</div>;
    $[33] = t19;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== onClick || $[37] !== t13 || $[38] !== t17 || $[39] !== t18 || $[40] !== t21 || $[41] !== t9) {
    t22 = <div className={t8}><button type="button" aria-label={t9} onClick={onClick} className={t13}>{t17}{t18}{t21}</button></div>;
    $[36] = onClick;
    $[37] = t13;
    $[38] = t17;
    $[39] = t18;
    $[40] = t21;
    $[41] = t9;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t1 || $[44] !== t22 || $[45] !== t7) {
    t23 = <article className={t1}>{t7}{t22}</article>;
    $[43] = t1;
    $[44] = t22;
    $[45] = t7;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  return t23;
};